<template>
    <span>Logged out..</span>
</template>

<script>
import axios from 'axios'

export default {
	name: 'logout',
	beforeCreate() {
        this.$root.loader = !true
        axios.post('/passport/logout').then(() => {
            localStorage.removeItem('token')
            this.$router.push('/user/login')
        })
	},
}
</script>
